<template>
  <div style="min-height: 92vh">
    <h3>Reporte de inventarios</h3>
    <v-autocomplete
      label="Departamentos"
      v-model="selectDep"
      item-text="Nombre"
      item-value="id"
      :items="departamentos"
    ></v-autocomplete>
    <v-autocomplete
      label="Centro de consumo"
      v-model="selectOrigen"
      item-text="Nombre"
      item-value="id"
      :items="origenes"
    ></v-autocomplete>
    <v-btn color="green" dark @click="exportExcel"
      ><v-icon>mdi-file-excel-box</v-icon>
        Exportar a Excel
        <!-- <download-excel
        type="xls"
        name="Reporte General"
        :data="global_prod"
        :fields="json_fields"
      >
      </download-excel> -->
    </v-btn>
    <uv-data-table
      :config="config"
      :data="global_prod"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>

    <modal v-model="showModal" :showFooter="false" title="Productos">
      <ProductosForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </ProductosForm>
    </modal>
    <modal
      v-model="showModalModificador"
      :showFooter="false"
      title="Modificadores Productos"
    >
      <ProductosModificadores
        :edit="editMode"
        :key="formIndex"
        @toggle="showModalModificador = false"
        :dataEdit="editData"
        @successData="saveModificadores"
      />
    </modal>
    <modal
      v-model="showModalPrecio"
      :showFooter="false"
      title="Modificar Precios"
    >
      <ProductoPrecioForm
        :edit="editMode"
        :key="formIndex"
        @toggle="showModalPrecio = false"
        :dataEdit="editData"
      >
      </ProductoPrecioForm>
    </modal>
    <modal
      v-model="showModalPrecioPorcentaje"
      :showFooter="false"
      title="Modificar Precios"
    >
      <ProductoPrecioProcentajeForm
        :edit="editMode"
        :key="formIndex"
        @toggle="showModalPrecioPorcentaje = false"
        :dataEdit="editData"
      >
      </ProductoPrecioProcentajeForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProductosForm from "../Productos/ProductosForm.vue";
import ProductoPrecioForm from "../Productos/ProductoPrecioForm.vue";
import ProductoPrecioProcentajeForm from "../Productos/ProductoPrecioPorcentajeForm.vue";
import ProductosModificadores from "../Productos/ProductosModificadores.vue";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel";
import { mapActions } from "vuex";
export default {
  name: "ProductosCRUD",
  components: {
    modal,
    uvDataTable,
    ProductosForm,
    ProductoPrecioForm,
    ProductoPrecioProcentajeForm,
    ProductosModificadores,
  },
  props: [],
  data() {
    return {
      json_fields: {
        Nombre: "Nombre",
        Marca: "Marca",
        Codigo: "Codigo",
        "Centro de consumo": "NombreOrigen",
        Categoría: "categoria_name",
        Existencia: "Price.Stock",
        Precio: "Price.PV",
      },
      selectOrigen: "ALL",
      selectDep: "ALL",
      MainDepartamento: "",
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      Categories: [],
      editData: [],
      products: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      showModalPrecio: false,
      showModalModificador: false,
      showModalPrecioPorcentaje: false,
      showModalRecetas: false,
      config: {
        disablePagination: true,
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [],
        fields: [
          {
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Marca",
            value: "Marca",
          },
          {
            text: "Codigo",
            value: "Codigo",
          },
          {
            text: "Centro de consumo",
            value: "NombreOrigen",
          },
          {
            text: "Categoria",
            value: "categoria_name",
          },
          {
            text: "Existencia",
            value: "existenciaData", //'Existencia',
            format: (row) => {
              return row["Price"].Stock;
            },
          },
          {
            text: "Precio",
            value: "existenciaPrecio",
            format: (row) => {
              let html = "";
              row["existenciaPrecio"].forEach((element) => {
                html += row["Price"].PV + " MXN<br/>";
              });
              return html;
              //return '$'+row['Precio']+' '+row['Moneda']+'';
            },
          },
        ],
      },
    };
  },
  methods: {
    exportExcel() {
      const options = {
        json_fields: this.json_fields
      }
     GenericExcelExporter.generateExcelBuffer(this.global_prod, options)
       .then(buffer => {
         const blob = new Blob([buffer], {
           type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         });
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;
         link.download = "Inventario.xlsx";
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);
       })
       .catch(err => console.error("Error exportando Excel:", err));
   },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProducto") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editProducto") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
      if (buttonId == "editPrecio") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getProductoById(idSelected[0]);
        this.showModalPrecio = true;
      }
      if (buttonId == "deleteProducto") {
        this.deleteProducto(idSelected[0]);
      }
      if (buttonId == "editPrecioMasivo") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};
        this.showModalPrecioPorcentaje = true;
      }
      if (buttonId == "adminModificadores") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalModificador = true;
      }
      if (buttonId == "adminIngredientes") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.global_prod,
          "id",
          idSelected[0]
        );
        this.showModalRecetas = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    successData(data, doAction) {
      data.Precio = parseFloat(data.Precio);
      data.Orden = Number(data.Orden);
      if (doAction == "CREATE") {
        this.addProduct(data);
      } else if (doAction == "EDIT") {
        this.editProduct(data);
      }
    },
    async deleteProducto(id) {
      let datos = { Id: id };
      this.$alert.alertConfirm({
        action: "eliminar",
        obj: "el producto",
        route: "PDV-Productos-deleteProducto",
        data: datos,
        onSuccess: () => {
          this.getCategories();
        },
      });
    },
    editProduct(datos) {
      //datos.Departamento      =  this.MainDepartamento;
      this.$alert.alertConfirm({
        action: "editar",
        obj: "el producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    addProduct(datos) {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "el producto",
        route: "PDV-Productos-createProducto",
        data: datos,
        onSuccess: () => {
          this.toggleModal(false);
        },
      });
    },
    saveModificadores(datos) {
      this.$alert.alertConfirm({
        action: "actualizar",
        obj: "los modificadores del producto",
        route: "PDV-Productos-updateProducto",
        data: datos,
        onSuccess: () => {
          this.showModalModificador = false;
        },
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      const cats = await this.fetchCategories();
      this.Categories = cats.map((element) => ({
        ...element,
        Nombre: `${element.Nombre || ""}-${element.Departamento || ""}`,
      }));
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },

    async getProducts() {},
  },
  computed: {
    origenes() {
      let ori = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let origenes = this.$store.getters.getCentrosConsumo;
      origenes.forEach((orig) => {
        ori.push(orig);
      });
      return ori;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;

      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = [];
      prod.forEach((element) => {
        element.categoria_name = this.getCategoryById(element.Categoria).Nombre;
        if (element.Tipo != "Servicio" && !element.Dlat) {
          productos.push(element);
        }
        //element.Orden = (element.Orden)?element.Orden:0;
      });
      let productoOrigen = [];
      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            invData.push({
              Origen: origen.Origen,
              Price: productMatch[1],
              NombreOrigen: origen.nombreOrigen,
            });
            producto.Origen = origen.Origen;
            producto.Price = productMatch[1];
            producto.NombreOrigen = origen.nombreOrigen;
            productoOrigen.push(producto);
          }
        });

        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      let data = productoOrigen;
      if (this.selectDep != "ALL") {
        data = JSON.parse(JSON.stringify(productoOrigen)).filter((prod) => {
          if (
            prod.Departamentos &&
            prod.Departamentos.includes(this.selectDep)
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.selectOrigen != "ALL") {
        data = JSON.parse(JSON.stringify(data)).filter((prod) => {
          if (prod.Origen && prod.Origen == this.selectOrigen) {
            return true;
          } else {
            return false;
          }
        });
      }
      //let sortReservations = this.$_.orderBy(data, "categoria_name", "asc");
      let sortReservations = data.sort((a, b) => {
        if (b.categoria_name > a.categoria_name) return -1;
        if (b.categoria_name < a.categoria_name) return 1;
        if (b.Nombre > a.Nombre) return -1;
        if (b.Nombre < a.Nombre) return 1;
        return 0;
        /*let first = b.categoria_name < a.categoria_name;
        if (first) {
          let second = b.Nombre < a.Nombre;
          if(second){
            return 1
          }else{
            return -1
          }
        } else {
          return -1;
        }*/
      });

      return sortReservations;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getCategories();
    //this.getProducts();
  },
};
</script>
